module.exports = __webpack_public_path__ + "static/media/combo_8.4a8f9509.png";